<template>
    <ul class="c-pagination text-center">
        <li v-for="link in links" :class="{ 'c-pagination__disabled': !link.url }">
            <button :disabled="!link.url" :class="{ 'c-pagination__current': link.active }" @click="$emit('selectPage', link.url)" v-html="link.label"></button>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        links: {
            type: Object,
            required: true,
        },
    },
}
</script>
